<template>
  <Card >
    <div v-if="user">
      <div class="row">
        <div class="col-12 col-md-4">
          <CustomInput v-model="filter.has_plan" type="select" label="پلن فعال" placeholder="انتخاب کنید" :select-options="has_plan_options" select-label="title"></CustomInput>
        </div>
      </div>
      <LocalDataTable :ajax-link="ajaxLink" :columns="columns"></LocalDataTable>
    </div>
    <div class="alert alert-danger" v-if="error">{{error}}</div>
  </Card>

</template>

<script>
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import {UserApi} from "@/api/UserApi";
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
export default {
name: "invitedUserList",
  components: {CustomInput, Card, LocalDataTable},
  props : ['id'],
  data()
  {
    return {
      has_plan_options : [
        {title : 'پلن فعال دارد',value : 1},
        {title : 'پلن فعال ندارد',value: 0}
      ],
      filter : {},
      id : this.$route.params.id,
      user :null,
      error : null,
      ajaxLink : '',
      columns : [{title : 'عنوان'},{title : 'نوع کاربر'},{title :'شماره تلفن'},
        {title : 'صنف'},{title : 'وضعیت'},{title : '<i class="far fa-cogs"></i>'},],
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('');
    this.setShowHead(true);
    this.initPage();
  },
  methods :
  {
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.id = this.$route.params.id;
      const result = await UserApi.getUserInfoForEdit(this.id);
      if (result.ok)
      {
        this.ajaxLink = 'admin/user/invited/list/'+this.id;
        this.user = result.user;
        const title = 'لیست کاربران دعوت شده توسط '+this.user.title;
        this.setPageTitle(title);
      }
      else
         this.error = result.error;
      this.setPageLoading(false);
    },
    changeFilters()
    {
      let ajaxLink = 'admin/user/invited/list/'+this.id+'?t=1';
      if (this.filter.has_plan)
      {
        const has_plan = this.filter.has_plan.value;
        ajaxLink += '&has_plan='+has_plan;
      }
      this.ajaxLink = ajaxLink;

    }
  },
  watch:{
  filter : {
    handler()
    {
      this.changeFilters();
    },deep : true
  }
  }
}
</script>

<style scoped>

</style>